// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"avatarNameDetail_subtitle__en07P","popOut":"avatarNameDetail_popOut__UYiEg"};